import { Injectable } from "@angular/core";
import { Observable, Observer } from 'rxjs';
import { ConnectionService } from './../services/connection.service';
import { ModalService } from './../services/modal.service';
import { PostauthComponent } from './../flashworlds/postauth.component';
import { NeverumeComponent } from './../neverume.component';
/*data core*/

@Injectable({
	providedIn: 'root'
})
export class EventRunner {

	/*todo: tpl map,
	 *todo:  buffer sync*/

	constructor(private сonnectionService: ConnectionService, private modalService: ModalService) {

	}

	listner(c: any) {
		let assocArray: { [key: string]: any } = {};
		console.log(c);
		if (!(c['fd'] == undefined)) {
			assocArray[0][0][0] = c;
		} else {
			c.forEach((value: any, key: any) => {
				Object.keys(value).forEach((k: any) => {
					let v = value[k];
					Object.keys(v).forEach((i: any) => {
						let s = v[i];
						if (!assocArray[key]) {
							assocArray[key] = [];

						}
						if (!assocArray[key][k]) {
							assocArray[key][k] = [];

						}
						if (!assocArray[key][k][i]) {
							assocArray[key][k][i] = [];
						}
						assocArray[key][k][i] = s;
					});

				});
			});
		}

		Object.keys(assocArray).forEach(key => {
			let valueArray = assocArray[key];
			Object.keys(valueArray).forEach(ark => {
				let value = valueArray[ark];
				Object.keys(value).forEach(k => {
					let v = value[k];
					console.log(v);
					switch (v['event']) {
						case 'connection':
							let connectionstatus = <string>v.devicestatus;
							this.onConnection(connectionstatus);
							break;
						case 'modal':
							this.modalService.updateMpdal(v.ngroute);
							this.modalService.openModal();
							//	this.onNickNameSet(v);
							break;
						case 'signverify':
							this.onSignVerify(v);
							break;
						case 'openurl':
							this.openUrl(v);
							break;
					}
				});
			});
		});
	}

	onNickNameSet(status: any) {
		//sthis.сonnectionService.postauthComponent.openModal();
	}

	onConnection(status: string) {
		console.log(status);
		this.сonnectionService.updateConnectionStatus(status);
	}

	openUrl(v: any) {
		window.open(v.url, "_blank", "popup");
	}

	onSignVerify(v: any) {
		console.log('signverfy');
		console.log(v);
		let local = localStorage.setItem("local", v.device);
		let session = sessionStorage.setItem('session', v.softhash);

	}
	onSessionUpdate(v: any) {

		console.log('sessionupdate');

		let docketlocalsession = sessionStorage.setItem("docketlocal", v.localdocket);
		let docket = sessionStorage.setItem("docket", v.docket);
		let local = sessionStorage.setItem("local", v.device);
		let session = sessionStorage.setItem('session', v.softhash);
		let lssofthash = localStorage.setItem('softhash', v.softhash);
		let nativedocket = localStorage.setItem('docket', v.softhash);

	}

	onLocalSessionUpdate(v: any) {

		console.log('localsessionupdates');
		let docket = localStorage.setItem('docket', v.docket);
		let session = localStorage.setItem('session', v.softhash);
		let softhash = localStorage.setItem('softhash', v.softhash);
		let docketlocal = localStorage.setItem('nativeocket', v.softhash);

	}

	onLook() {

	}
}